export function getSubdomainIndex() {
  const domainParts = window.location.hostname.split('.');
  return domainParts.length - 1;
}
